<template>
    <div v-if="user != null && !$route.meta.hideNavbar">
        <div v-if="isMobile" style="position: fixed; top: 70px; z-index: 2;">
            <q-btn 
                flat 
                round 
                icon="menu"
                color="primary"
                @click="drawer = true"
            />
        </div>
        <q-drawer
            show-if-above
            v-model="drawer"
            :width="150"
            :breakpoint="1024"
            style="color:#004646 !important"
            v-if="user != null"
            @click.capture="isMobile && (drawer = false)"
        >
            <q-scroll-area class="fit">
                <div v-if="user.is_admin == 0 && rol.id != 4" >
                    <q-list>
                        <template v-for="(menuItem, index) in menuList" :key="index">
                            <q-expansion-item
                            expand-icon-toggle
                            expand-separator
                            :icon="menuItem.icon"
                            :label="menuItem.label"
                            v-if="menuItem.collapse == true"
                            dense-toggle
                            class="rc__sidebarCollapseItem flex-center"
                            :header-style="{ background:' #19B2A3 !important;' , color:'white !important;'}"
                            
                            >
                            <q-list>
                                <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                                     <div class="rc__itemWrapper">
                                         <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                             <q-item-section >
                                                 <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                             </q-item-section>
                                             <q-item-section>
                                                 {{ submenuItem.label }}
                                             </q-item-section>
                                         </q-item>
                                     </div>
                                </template>
                            </q-list>
                            </q-expansion-item>

                            <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                    <q-item-section>
                                        <q-icon :name="menuItem.icon" size="1.5rem" />
                                    </q-item-section>
                                    <q-item-section>
                                        {{ menuItem.label }}
                                    </q-item-section>
                            </q-item>
                        </template>
                    </q-list>
                </div>
                <div v-else-if="user.is_admin == 1">
                    <q-list>
                        <template v-for="(menuItem, index) in menuListAdmin" :key="index">
                            <q-expansion-item
                            expand-separator
                            :icon="menuItem.icon"
                            :label="menuItem.label"
                            v-if="menuItem.collapse == true"
                            dense-toggle
                            class="rc__sidebarCollapseItem flex-center"
                            >
                            <q-list>
                                <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                                     <div class="rc__itemWrapper">
                                         <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                             <q-item-section >
                                                 <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                             </q-item-section>
                                             <q-item-section>
                                                 {{ submenuItem.label }}
                                             </q-item-section>
                                         </q-item>
                                     </div>
                                </template>
                            </q-list>
                            </q-expansion-item>
                            <div class="rc__itemWrapper">
                                <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                        <q-item-section>
                                            <q-icon :name="menuItem.icon" size="1.5rem" />
                                        </q-item-section>
                                        <q-item-section>
                                            {{ menuItem.label }}
                                        </q-item-section>
                                </q-item>
                            </div>
                        </template>
                    </q-list>
                </div>
                <!-- Menu de fondeador -->
                <div v-else-if="rol.id == 4">
                    <q-list>
                        <template v-for="(menuItem, index) in menuListFondeador" :key="index">
                            <q-expansion-item
                            expand-separator
                            :icon="menuItem.icon"
                            :label="menuItem.label"
                            v-if="menuItem.collapse == true"
                            dense-toggle
                            class="rc__sidebarCollapseItem flex-center"
                            >
                            <q-list>
                                <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                                    <div class="rc__itemWrapper">
                                        <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                            <q-item-section >
                                                <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                            </q-item-section>
                                            <q-item-section>
                                                {{ submenuItem.label }}
                                            </q-item-section>
                                        </q-item>
                                    </div>
                                </template>
                            </q-list>
                            </q-expansion-item>

                            <div class="rc__itemWrapper">
                                <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                        <q-item-section>
                                            <q-icon :name="menuItem.icon" size="1.5rem" />
                                        </q-item-section>
                                        <q-item-section>
                                            {{ menuItem.label }}
                                        </q-item-section>
                                </q-item>
                            </div>
                        </template>
                    </q-list>
                </div>
            </q-scroll-area>
        </q-drawer>
    </div>
    <q-drawer
        show-if-above
        v-model="drawer"
        :width="150"
        :breakpoint="1263"
        style="color:#004646"
        v-if="user != null"
    >
        <q-scroll-area class="fit">
            <div v-if="user.is_admin == 0 && rol.id != 4 && user.control_account == 0">
                <q-list>
                    <template v-for="(menuItem, index) in menuList" :key="index">
                        <q-expansion-item
                        expand-icon-toggle
                        expand-separator
                        :icon="menuItem.icon"
                        :label="menuItem.label"
                        v-if="menuItem.collapse == true"
                        dense-toggle
                        class="rc__sidebarCollapseItem flex-center"
                        :header-style="{ background:' #19B2A3 !important;' ,color:'white !important;'}"
                        
                        >
                        <q-list>
                            <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                                <div class="rc__itemWrapper">
                                    <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                        <q-item-section >
                                            <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                        </q-item-section>
                                        <q-item-section>
                                            {{ submenuItem.label }}
                                        </q-item-section>
                                    </q-item>
                                </div>
                            </template>
                        </q-list>
                        </q-expansion-item>

                        <div class="rc__itemWrapper">
                            <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                    <q-item-section>
                                        <q-icon :name="menuItem.icon" size="1.5rem" />
                                    </q-item-section>
                                    <q-item-section>
                                        {{ menuItem.label }}
                                    </q-item-section>
                            </q-item>
                        </div>
                    </template>
                </q-list>
            </div>
            <div v-else-if="user.is_admin == 1 && user.control_account == 0">
                <q-list>
                    <template v-for="(menuItem, index) in menuListAdmin" :key="index">
                        <q-expansion-item
                        expand-separator
                        :icon="menuItem.icon"
                        :label="menuItem.label"
                        v-if="menuItem.collapse == true"
                        dense-toggle
                        class="rc__sidebarCollapseItem flex-center"
                        >
                        <q-list>
                            <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                            <div class="rc__itemWrapper">
                                <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                    <q-item-section >
                                        <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                    </q-item-section>
                                    <q-item-section>
                                        {{ submenuItem.label }}
                                    </q-item-section>
                                </q-item>
                            </div>
                            </template>
                        </q-list>
                        </q-expansion-item>

                        <div class="rc__itemWrapper">
                            <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                    <q-item-section>
                                        <q-icon :name="menuItem.icon" size="1.5rem" />
                                    </q-item-section>
                                    <q-item-section>
                                        {{ menuItem.label }}
                                    </q-item-section>
                            </q-item>
                        </div>
                    </template>
                </q-list>
            </div>
            <!-- Menu de fondeador -->
            <div v-else-if="rol.id == 4 && user.control_account == 0">
                <q-list>
                    <template v-for="(menuItem, index) in menuListFondeador" :key="index">
                        <q-expansion-item
                        expand-separator
                        :icon="menuItem.icon"
                        :label="menuItem.label"
                        v-if="menuItem.collapse == true"
                        dense-toggle
                        class="rc__sidebarCollapseItem flex-center"
                        >
                        <q-list>
                            <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                            <div class="rc__itemWrapper">
                                <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                    <q-item-section >
                                        <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                    </q-item-section>
                                    <q-item-section>
                                        {{ submenuItem.label }}
                                    </q-item-section>
                                </q-item>
                            </div>
                            </template>
                        </q-list>
                        </q-expansion-item>
                        <div class="rc__itemWrapper">
                            <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                    <q-item-section>
                                        <q-icon :name="menuItem.icon" size="1.5rem" />
                                    </q-item-section>
                                    <q-item-section>
                                        {{ menuItem.label }}
                                    </q-item-section>
                            </q-item>
                        </div>
                    </template>
                </q-list>
            </div>
            <!-- Menu control de usuarios -->
            <div v-else-if="user.control_account == 1">
                <q-list>
                    <template v-for="(menuItem, index) in menuListControl" :key="index">
                        <q-expansion-item
                        expand-separator
                        :icon="menuItem.icon"
                        :label="menuItem.label"
                        v-if="menuItem.collapse == true"
                        dense-toggle
                        class="rc__sidebarCollapseItem flex-center"
                        >
                        <q-list>
                            <template v-for="(submenuItem, index) in menuItem.submenu" :key="index">
                                <div class="rc__itemWrapper">
                                    <q-item class="rc__sidebarItems flex-center" clickable :to="{name: submenuItem.to}">
                                        <q-item-section >
                                            <q-icon :name="submenuItem.icon" size="1.5rem"/>
                                        </q-item-section>
                                        <q-item-section>
                                            {{ submenuItem.label }}
                                        </q-item-section>
                                    </q-item>
                                </div>
                            </template>
                        </q-list>
                        </q-expansion-item>
                        <div class="rc__itemWrapper">
                            <q-item class="rc__sidebarItems flex-center" :to="{name: menuItem.to}" clickable v-ripple v-if="menuItem.submenu != true && menuItem.collapse != true">
                                    <q-item-section>
                                        <q-icon :name="menuItem.icon" size="1.5rem" />
                                    </q-item-section>
                                    <q-item-section>
                                        {{ menuItem.label }}
                                    </q-item-section>
                            </q-item>
                        </div>
                    </template>
                </q-list>
            </div>
        </q-scroll-area>
    </q-drawer>
</template>

<style lang="scss">
$primary-600: #19B2A3;

.rc__sidebarItems{
    display: flex;
    flex-direction: column !important;
    flex-wrap: wrap;
    font-weight: 600 !important;
    font-size: 12px !important;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
}
.rc__sidebarItems:hover{
    background: $primary-600 !important;
    color: white !important;
}
.rc__sidebarCollapseItem .q-item.q-item-type {
    display: flex;
    flex-direction: column !important;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-size: 12px !important;
    font-weight: 600 !important;

}
.rc__sidebarCollapseItem .q-item__section.q-item__section--side{
    display: flex;
    justify-content: center;
    align-items: center;
    left: 50px;
    bottom: 20px;
}

.rc__sidebarCollapseItem .q-item__section.q-item__section--side.q-item__section--avatar{
    margin-left: 11px;
}

.rc__sidebarCollapseItem.q-expansion-item.q-expansion-item--expanded .q-item__section.q-item__section--side{
    color: $primary-600 !important;   
}
.rc__sidebarCollapseItem.q-expansion-item.q-expansion-item--expanded .q-item__section.q-item__section--side.q-item__section--avatar{
    color: $primary-600 !important;   
}
.rc__sidebarCollapseItem.q-expansion-item.q-expansion-item--expanded .q-item__label{
    color: $primary-600 !important;   
}


.rc__sidebarCollapseItem.q-expansion-item.q-expansion-item--expanded .q-item.q-item-type.row.no-wrap.q-item--clickable.q-link.cursor-pointer.q-focusable.q-hoverable:hover .q-focus-helper{
    color: white !important;
}
.q-item.q-router-link--active, .q-item--active {
    background: $primary-600 !important;
    color: white !important;
}

$primary-600: #19B2A3;

.rc__itemWrapper {
  padding: 4px 8px;
}

.rc__sidebarItems {
  display: flex;
  flex-direction: column !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: all 0.2s ease;
  border-radius: 5px;
}

.rc__sidebarItems:hover {
  background: $primary-600 !important;
  color: white !important;
  border-radius: 5px;
}

.q-item.q-router-link--active,
.q-item--active {
  background: $primary-600 !important;
  color: white !important;
  border-radius: 5px;
}
</style>

<script>
import { ref, computed } from 'vue'
import { useQuasar } from 'quasar'
import { menuList, menuListAdmin, menuListFondeador, menuListControl } from "@/models/Links";
import { mapState } from 'vuex'

export default {
  name: "SideBar",
  computed: mapState(['user', 'rol']),
  setup() {
    const $q = useQuasar()
    const isMobile = computed(() => $q.screen.lt.md) // < 1024px
    const drawer = ref(!isMobile.value) // abierto desktop, cerrado mobile

    function closeDrawerOnNavigate() {
      if (isMobile.value) drawer.value = false
    }

    return {
      isMobile,
      drawer,
      menuList, menuListAdmin, menuListFondeador, menuListControl,
      closeDrawerOnNavigate
    }
  }
}
</script>